export default {
  POLICY_STATE_DRAFT: -1,
  POLICY_STATE_IN_APPROVAL: 0,
  POLICY_STATE_APPROVED: 1,
  POLICY_STATE_ACTIVE: 2,
  POLICY_STATE_MATURED: 3,
  POLICY_STATE_CANCELLED: 4,
}
